import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { createEntity, getEntity, reset, updateEntity } from './env-var.reducer';

export const EnvVarUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const envVarEntity = useAppSelector(state => state.envVar.entity);
  const loading = useAppSelector(state => state.envVar.loading);
  const updating = useAppSelector(state => state.envVar.updating);
  const updateSuccess = useAppSelector(state => state.envVar.updateSuccess);

  const handleClose = () => {
    navigate(`/env-var${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.orgId !== undefined && typeof values.orgId !== 'number') {
      values.orgId = Number(values.orgId);
    }
    if (values.flowId !== undefined && typeof values.flowId !== 'number') {
      values.flowId = Number(values.flowId);
    }

    const entity = {
      ...envVarEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...envVarEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tycheApp.envVar.home.createOrEditLabel" data-cy="EnvVarCreateUpdateHeading">
            <Translate contentKey="tycheApp.envVar.home.createOrEditLabel">Create or edit a EnvVar</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="env-var-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('tycheApp.envVar.level')} id="env-var-level" name="level" data-cy="level" type="text" />
              <ValidatedField label={translate('tycheApp.envVar.key')} id="env-var-key" name="key" data-cy="key" type="text" />
              <ValidatedField label={translate('tycheApp.envVar.value')} id="env-var-value" name="value" data-cy="value" type="text" />
              <ValidatedField label={translate('tycheApp.envVar.orgId')} id="env-var-orgId" name="orgId" data-cy="orgId" type="text" />
              <ValidatedField label={translate('tycheApp.envVar.flowId')} id="env-var-flowId" name="flowId" data-cy="flowId" type="text" />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/env-var" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EnvVarUpdate;
